import { render, staticRenderFns } from "./AddressSearch.vue?vue&type=template&id=653f623b&scoped=true&"
import script from "./AddressSearch.vue?vue&type=script&lang=js&"
export * from "./AddressSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddressSearch.vue?vue&type=style&index=0&id=653f623b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f623b",
  null
  
)

export default component.exports